import type {
  ICountDiagram,
  IGroupLine,
  IGroupLineEdit,
  IGroupLineEdit2
} from './../interfaces/index'
import type { IFilterPayments, IFilterPaymentsResult } from './payments'
import type { AxiosResponse } from 'axios'

import $api, { schedule } from '.'
export interface IParamGroupTable {
  countRows: number
  currentPage: number
  dayOfWeek?: string
  groupIdentifier?: string
}
export interface IGroupTableResult {
  data: IGroupLine[]
  status: number
  count: string
}
export interface IGroupTableResultEdit {
  data: IGroupLineEdit
  status: number
}
export interface IEditInforamtionParams {
  groupNumber: string
}

export interface IUpdateData {
  groupNumber: string
  data: IGroupLineEdit
}
export interface getCountParam {
  entIds?: string
}
export interface IUpdateDataProps {
  groupNumber: string
  data: IGroupLineEdit2
}

export default class GroupSchedule {
  static async getCount(param: getCountParam): Promise<ICountDiagram> {
    return $api
      .get(`${schedule}/getGroupsCountByDays`, { params: param })
      .then((response: AxiosResponse) => {
        return response.data
      })
  }

  static async getGroupSheduleTable(param: IParamGroupTable): Promise<IGroupTableResult> {
    return $api
      .get<IGroupTableResult>(`${schedule}/getGroupSchedules`, { params: param })
      .then((response: AxiosResponse) => {
        return {
          data: response.data.data,
          count: response.data.count.count,
          status: response.status
        }
      })
  }

  static async getEditInformation(params: IEditInforamtionParams): Promise<IGroupTableResultEdit> {
    return $api
      .get<IGroupTableResultEdit>(`${schedule}/getGroupScheduleData`, { params })
      .then((response: AxiosResponse) => {
        return { data: response.data.data, status: response.status }
      })
  }

  static async getFilter(params: IFilterPayments): Promise<IFilterPaymentsResult> {
    return $api
      .get<IFilterPaymentsResult>(`${schedule}/getGroups`, { params })
      .then((response: AxiosResponse) => {
        return { ...response.data }
      })
  }

  static async updateRow(params: IUpdateDataProps): Promise<AxiosResponse> {
    const { groupNumber, data } = params
    return $api
      .post(`${schedule}/updateGroupSchedule`, { groupNumber, data })
      .then((response: AxiosResponse) => {
        return response
      })
  }
}
